export default "__VITE_ASSET__90fb35f2__"